import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
function changeStr(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
var requireComponent = require.context('./', false, /\.vue$/);
// 查找同级目录下以vue结尾的组件
var install = function install() {
  requireComponent.keys().forEach(function (fileName) {
    // console.log(fileName, 'fileName')
    var config = requireComponent(fileName);
    // console.log(config, 'config') // ./child1.vue 然后用正则拿到child1
    var componentName = changeStr(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''));
    // console.log(componentName, 'componentName')
    Vue.component(componentName, config.default || config);
  });
};
export default {
  install: install // 对外暴露install方法
};